import React, { type FC } from 'react'
import { SkeletonBox } from '@moonpig/launchpad-components'
import { breakpoint, styled } from '@moonpig/launchpad-utils'
import { StyledCell, StyledGrid } from './ProductGrid'

const SKELETON_COUNT_MOBILE = 4
const SKELETON_COUNT_DESKTOP = 12

const StyledSkeletonGrid = styled(StyledGrid)`
  & > *:nth-child(n + ${SKELETON_COUNT_MOBILE + 1}) {
    display: none;
  }

  ${breakpoint('md')} {
    & > *:nth-child(n + ${SKELETON_COUNT_MOBILE + 1}) {
      display: block;
    }
  }
`

const StyledSkeletonBox = styled(SkeletonBox)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`

export const SkeletonProductGrid: FC = ({ ...rest }) => (
  <StyledSkeletonGrid
    data-testid="more-like-this-product-grid-skeleton"
    aria-busy="true"
    aria-live="polite"
    {...rest}
  >
    {Array.from({ length: SKELETON_COUNT_DESKTOP }).map((_, index) => (
      <StyledCell
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        data-testid="more-like-this-product-grid-skeleton-item"
      >
        <StyledSkeletonBox
          colours={{
            background: 'colorBlack05',
            effect: 'colorBlack10',
          }}
        />
      </StyledCell>
    ))}
  </StyledSkeletonGrid>
)
